import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FC } from 'react';

import Segment from '../../interfaces/Segment';

interface DeleteSegmentDialogProps {
  segment: Segment;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteSegmentDialog: FC<DeleteSegmentDialogProps> = ({
  segment,
  onDelete,
  onClose,
}) => {
  return (
    <Dialog open onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Delete '{segment.name}' Segment</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Are you sure you want to delete <strong>{segment.name}</strong>{' '}
          Segment?
          <Alert severity='error' sx={{ mt: 2 }}>
            You can't undo this action
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button color='error' onClick={onDelete} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteSegmentDialog;
